



















import { computed, defineComponent, ref } from "@vue/composition-api";
import TipController from "@/components/TipController";
import PostTippingModal from "./components/PostTippingModal.vue";

export default defineComponent({
  name: "PostTipping",
  components: { TipController, PostTippingModal },
  props: {
    feedId: { type: String, required: true },
    subjectType: { type: String, required: false, default: "content_set" },
  },
  setup(props) {
    const linkSubject = computed(() => {
      return { subjectId: props.feedId, subjectType: props.subjectType };
    });

    const success = ref(false);

    const setSuccess = () => {
      success.value = true;
    };
    return {
      linkSubject,
      success,
      setSuccess,
    };
  },
});
